import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Stack,
  Typography,
} from "@mui/joy";
import Logo from "assets/academix-logo-word.svg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useForgotPasswordForm from "./utils/useForgotPasswordForm";
import { Link } from "react-router-dom";
import { AUTH_ROUTE } from "app/constants/route";

const ForgotPasswordForm = () => {
  const {
    isLoading,
    formValue,
    updateFormValue,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    step,
    onSubmitRequestCode,
    onSubmitConfirmReset,
    resendCode,
  } = useForgotPasswordForm({});

  return (
    <Stack spacing={2} sx={{ justifyContent: "start", width: 1 }}>
      <Stack
        direction={{ md: "row" }}
        spacing={2}
        alignItems={{ xs: "center", md: "end" }}
      >
        <Typography level="h1" sx={{ lineHeight: 1 }}>
          Reset Password
        </Typography>
      </Stack>
      <Typography level="body-md" textAlign={{ xs: "center", md: "left" }}>
        {step === "request"
          ? "Enter your email to receive a reset code"
          : "Enter the code sent to your email and your new password"}
      </Typography>

      {step === "request" ? (
        <Stack spacing={2} sx={{ pt: 1 }}>
          <form onSubmit={onSubmitRequestCode} style={{ gap: "1rem", display: "grid" }}>
            <FormControl required>
              <FormLabel>Email</FormLabel>
              <Input
                type="email"
                name="username"
                placeholder="Enter your email"
                value={formValue.username}
                onChange={(e) => updateFormValue("username", e.target.value)}
              />
            </FormControl>

            <Stack gap={2} sx={{ mt: 2 }}>
              <Button type="submit" loading={isLoading} fullWidth size="lg">
                Send Reset Code
              </Button>
              <Stack
                gap={1}
                direction="row"
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography level="body-sm">Remember your password?</Typography>
                <Link to={AUTH_ROUTE}>
                  <Typography level="body-sm" color="primary">
                    Sign In
                  </Typography>
                </Link>
              </Stack>
            </Stack>
          </form>
        </Stack>
      ) : (
        <Stack spacing={2} sx={{ pt: 1 }}>
          <form onSubmit={onSubmitConfirmReset} style={{ gap: "1rem", display: "grid" }}>
            <FormControl required>
              <FormLabel>Verification Code</FormLabel>
              <Input
                type="text"
                name="confirmationCode"
                placeholder="Enter the code from your email"
                value={formValue.confirmationCode}
                onChange={(e) => updateFormValue("confirmationCode", e.target.value)}
              />
            </FormControl>

            <FormControl required>
              <FormLabel>New Password</FormLabel>
              <Input
                type={showPassword ? "text" : "password"}
                name="newPassword"
                placeholder="Enter new password"
                value={formValue.newPassword}
                onChange={(e) => updateFormValue("newPassword", e.target.value)}
                endDecorator={
                  <IconButton onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                }
              />
            </FormControl>

            <FormControl required>
              <FormLabel>Confirm New Password</FormLabel>
              <Input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm new password"
                value={formValue.confirmPassword}
                onChange={(e) => updateFormValue("confirmPassword", e.target.value)}
                endDecorator={
                  <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                }
              />
            </FormControl>

            <Stack gap={2} sx={{ mt: 2 }}>
              <Button type="submit" loading={isLoading} fullWidth size="lg">
                Reset Password
              </Button>
              <Stack
                gap={1}
                direction="row"
                alignItems={"center"}
                justifyContent={"center"}
              >
                <Typography level="body-sm">Didn't receive the code?</Typography>
                <Typography
                  level="body-sm"
                  color="primary"
                  sx={{ cursor: "pointer" }}
                  onClick={resendCode}
                >
                  Resend
                </Typography>
              </Stack>
            </Stack>
          </form>
        </Stack>
      )}
    </Stack>
  );
};

export default ForgotPasswordForm;
